import { useState } from "react";

import useResizeObserver2 from "./useResizeObserver2";

const useHeight = (ref) => {
  // Lazy on purpose: as a plain argument this read ran on every render and
  // forced a style + layout pass React then threw away (mount is the only
  // render that uses it). Reading clientHeight once at mount is fine.
  const [height, setHeight] = useState(() => ref.current?.clientHeight || 0);

  useResizeObserver2(ref, () => {
    setHeight(ref.current?.clientHeight || 0);
  });

  return height;
};

export default useHeight;
